function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "3rd-party-testing_svg__a",
  x1: "0%",
  y1: "55.339%",
  y2: "55.339%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00907F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#48D59F"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#DCE1EC",
  strokeLinejoin: "round",
  strokeWidth: 6.982,
  d: "M72.508 72.491H27.563v-60h44.945z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#3rd-party-testing_svg__a)",
  strokeLinecap: "square",
  strokeWidth: 8.873,
  d: "M46.72 34.986c-8.003 8.003-20.98 8.003-28.983 0-8.004-8.004-8.004-20.98 0-28.983 8.003-8.004 20.98-8.004 28.983 0 8.003 8.003 8.003 20.979 0 28.983zm0 0L69 57.265 46.72 34.986z",
  transform: "matrix(-1 0 0 1 73 5)"
}));

function Svg3RdPartyTesting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 76
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3NiIgaGVpZ2h0PSI3NiI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iMCUiIHkxPSI1NS4zMzklIiB5Mj0iNTUuMzM5JSI+PHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iIzAwOTA3RiIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iIzQ4RDU5RiIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PHBhdGggc3Ryb2tlPSIjRENFMUVDIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjYuOTgyIiBkPSJNNzIuNTA4IDcyLjQ5MUgyNy41NjN2LTYwaDQ0Ljk0NXoiLz48cGF0aCBzdHJva2U9InVybCgjYSkiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS13aWR0aD0iOC44NzMiIGQ9Ik00Ni43MiAzNC45ODZjLTguMDAzIDguMDAzLTIwLjk4IDguMDAzLTI4Ljk4MyAwLTguMDA0LTguMDA0LTguMDA0LTIwLjk4IDAtMjguOTgzIDguMDAzLTguMDA0IDIwLjk4LTguMDA0IDI4Ljk4MyAwIDguMDAzIDguMDAzIDguMDAzIDIwLjk3OSAwIDI4Ljk4M3ptMCAwTDY5IDU3LjI2NSA0Ni43MiAzNC45ODZ6IiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSA3MyA1KSIvPjwvZz48L3N2Zz4=";
export { Svg3RdPartyTesting as ReactComponent };